import { MediaImage, Page, Upload, WarningCircle } from 'iconoir-react';
import { ReactNode } from 'react';

import { classNames } from '@superfunnel/ui-core/utils';

function FileCard({
  rejected,
  className,
  children,
}: {
  rejected: boolean;
  className: string;
  children: ReactNode;
}) {
  return (
    <div
      className={classNames(
        'absolute flex h-16 w-13 items-center justify-center rounded-2lg border border-base-100 bg-white text-base-400 shadow-[0px_4px_12px_rgba(26,20,77,0.08)] dark:border-base-200 dark:bg-base-200 dark:text-base-500',
        rejected && 'opacity-60',
        className,
      )}
    >
      {children}
    </div>
  );
}

/** Two tilted file cards behind a brand upload badge, as in the chat drop overlay. */
export function DropIllustration({
  rejected = false,
  className,
}: {
  rejected?: boolean;
  className?: string;
}) {
  return (
    <div className={classNames('relative h-25 w-42', className)}>
      <FileCard rejected={rejected} className="top-[17px] left-3 rotate-10">
        <MediaImage width={20} height={20} />
      </FileCard>
      <FileCard
        rejected={rejected}
        className="top-[7px] left-[103px] -rotate-10"
      >
        <Page width={20} height={20} />
      </FileCard>
      <div
        className={classNames(
          'absolute top-7 left-13.5 flex size-15 items-center justify-center rounded-full text-white',
          rejected
            ? 'bg-error-500 shadow-[0px_8px_20px_-4px_rgba(217,51,51,0.3)] dark:bg-error-400'
            : 'bg-brand-500 shadow-[0px_8px_20px_-4px_rgba(107,77,242,0.35)]',
        )}
      >
        {rejected ? (
          <WarningCircle width={24} height={24} />
        ) : (
          <Upload width={24} height={24} />
        )}
      </div>
    </div>
  );
}
